import React from 'react';
import { Loader } from '@nbcuniversal-paint/nbcu-react-components';

const ComponentLoader = (): React.ReactElement => <Loader />;

export default ComponentLoader;
